import { useState, useEffect } from "react"
import "./Modal.css"

const ModalDetail = ({ show, closeModal, expediente }) => {
	const [data, set_data] = useState("")

	useEffect(() => {
		async function fetchData() {
			try {
				const responseDetail = await fetch(`/api/query/detail?id=${expediente}`)
				const dataDetail = await responseDetail.json()

				const lastThreeDigits = expediente.slice(-3)
				const responseActiveUser = await fetch(`/api/query/activeuser?lastThree=${lastThreeDigits}`)
				const dataActiveUser = await responseActiveUser.json()

				if (dataDetail !== null && dataActiveUser !== null) {
					set_data({ ...dataDetail, ...dataActiveUser })
				}
			} catch (error) {
				console.log(error)
			}
		}
		fetchData()
	}, [expediente])

	function renderCommentsTable(data) {
		const comments = [
			{
				title: "Comentarios de Pago",
				field: "Pago_comentarios",
				condition: data.estado === "Corregir Registro",
			},
			{ title: "Comentarios de Revisión", field: "Comentarios_Revision", condition: true },
			{ title: "Comentarios de Inspección", field: "Comentarios_Inspeccion", condition: true },
			{ title: "Comentarios de Tasar", field: "Comentarios_Tasar", condition: true },
		]

		const hasComments = comments.some(
			(comment) => data[comment.field] !== null && comment.condition
		)

		if (!hasComments) {
			return null
		}

		return (
			<table className="table-auto w-full mt-4">
				<thead>
					<tr>
						{comments.map(
							(comment, index) =>
								comment.condition && (
									<th key={index} className="px-4 py-2 text-left text-custom">
										{comment.title}
									</th>
								)
						)}
					</tr>
				</thead>
				<tbody>
					<tr>
						{comments.map(
							(comment, index) =>
								comment.condition && (
									<td key={index} className="border px-4 py-2">
										{data[comment.field]}
									</td>
								)
						)}
					</tr>
				</tbody>
			</table>
		)
	}

	const ConvertCoordinates = ({ coordinates }) => {
		const convert = (coord) => {
			const lat_length = coord.length / 2
			const lat = coord.slice(0, lat_length)
			const long = "-" + coord.slice(lat_length, lat_length * 2)
			return lat.slice(0, 2) + "." + lat.slice(2) + "," + long.slice(0, 3) + "." + long.slice(3)
		}

		return <>{convert(coordinates)}</>
	}

	return (
		<div className="record">
			<h1>CONSULTA DE CERTIFICACIÓN</h1>
			<hr />
			{data === null ? (
				<p className="text-center mt-8 text-xl text-red-500">No encontrado.</p>
			) : (
				<>
					<table className="tablet">
						<tbody>
							<tr>
								<td>
									<b>Expediente Nº:</b>
								</td>
								<td>{data?.expediente}</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Nombre Proyecto:</b>
								</td>
								<td>{data?.nombre}</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Datos del Solicitante:</b>
								</td>
								<td>{data?.nombre_solicitante}</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Email del Solicitante:</b>
								</td>
								<td>{data?.correo_solicitante}</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Teléfono del Solicitante:</b>
								</td>
								<td>{data?.telefono_solicitante}</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Coordenadas UTM:</b>
								</td>
								<td>
									{data?.coordenadas && (
										<ConvertCoordinates coordinates={data.coordenadas} />
									)}
								</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Estatus del Proceso:</b>
								</td>
								<td>{data?.estado}</td>
							</tr>
							<div className="hr" />
							<tr>
								<td>
									<b>Expediente en manos de:</b>
								</td>
								<td>{data?.fullname}</td>
							</tr>
						</tbody>
					</table>
					{renderCommentsTable(data)}
				</>
			)}
			<button onClick={closeModal}>Cerrar</button>
		</div>
	)
}

export default ModalDetail
